module.exports = __webpack_public_path__ + "static/media/joinusFood1.1716c75c.jpg";